import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { InvalidIntegerRedirector } from '../Shared/Util/InvalidIntegerRedirector';
import { DeletedListPage } from './container/DeletedListPage';
import { WithOktaAuthProps } from '../Auth/duck/Models';

interface IDeletedResponsesProps extends RouteComponentProps<{ pageNumber: string }> {
  auth: WithOktaAuthProps;
}

export const DeletedResponses: React.FC<IDeletedResponsesProps> = (props: IDeletedResponsesProps) => {
  return (
    <InvalidIntegerRedirector numberStrings={[props.match.params.pageNumber]}>
      <DeletedListPage
        {...{ currentPage: parseInt(props.match.params.pageNumber, 10) }} />
    </InvalidIntegerRedirector>
  );
};
